import { BrandGroupEntity } from '@/entities/brand-group.entity';
import { ProductGroupEntity } from '@/entities/product-group.entity';
import { ReviewEntity } from '@/entities/review.entity';
import { SocketIoEvents } from '@/events/socket-io.events';
import { Sort } from '@/types/sort.type';
import { useReviewsPageTransport } from '@/context/use-reviews-page-transport';
import { useReviewsPageTransportSync } from '@/context/reviews-page-transport.effects';

type UseReviewsPageProviderTransportConnectionArgs = {
    accessToken: string;
    clientId: string;
    events: SocketIoEvents;
    selectionSessionId: string;
    pickedProducts: string[];
    pickedBrandGroups: string[];
    products: ProductGroupEntity[];
    brandGroups: BrandGroupEntity[];
    reviewsOnPage: number;
    selectionReconcileRevision: number;
    filtersQuery: string[];
    sort: Sort;
    setSelectionSessionId: (value: string) => void;
    setPickedProducts: (value: string[]) => void;
    setPickedBrandGroups: (value: string[]) => void;
    setProductsState: (value: ProductGroupEntity[]) => void;
    setBrandGroupsState: (value: BrandGroupEntity[]) => void;
    setReviewsAndTotalState: (reviews: ReviewEntity[], total: number) => void;
    setReviewsOnPageState: (value: number) => void;
    onReviewAnswerJobDone: (review: ReviewEntity) => void;
    onReviewFeedItemChanged: (review: ReviewEntity) => void;
};

export const useReviewsPageProviderTransportConnection = ({
    accessToken,
    clientId,
    events,
    selectionSessionId,
    pickedProducts,
    pickedBrandGroups,
    products,
    brandGroups,
    reviewsOnPage,
    selectionReconcileRevision,
    filtersQuery,
    sort,
    setSelectionSessionId,
    setPickedProducts,
    setPickedBrandGroups,
    setProductsState,
    setBrandGroupsState,
    setReviewsAndTotalState,
    setReviewsOnPageState,
    onReviewAnswerJobDone,
    onReviewFeedItemChanged,
}: UseReviewsPageProviderTransportConnectionArgs) => {
    const {
        getProducts,
        getBrandGroups,
        refetchReviews,
        refetchReviewsAndProducts,
        setReviewsOnPage,
        isReviewsRefetchRunning,
    } = useReviewsPageTransport({
        clientId,
        accessToken,
        reviewsOnPage,
        filtersQuery,
        sort,
        setProductsState,
        setBrandGroupsState,
        setReviewsAndTotalState,
        setReviewsOnPageState,
    });

    useReviewsPageTransportSync({
        accessToken,
        clientId,
        selectionSessionId,
        pickedProducts,
        pickedBrandGroups,
        products,
        brandGroups,
        selectionReconcileRevision,
        events,
        setSelectionSessionId,
        setPickedProducts,
        setPickedBrandGroups,
        onReviewAnswerJobDone,
        onReviewFeedItemChanged,
        refetchReviewsAndProducts,
    });

    return {
        getProducts,
        getBrandGroups,
        refetchReviews,
        refetchReviewsAndProducts,
        setReviewsOnPage,
        isReviewsRefetchRunning,
    };
};
